import { combineReducers } from "redux";
//import { reducer as toastrReducer } from "react-redux-toastr";

import { globalData } from "./global.reducer";
import { authentication } from "./authentication.reducer";
import { alert } from "./alert.reducer";
import { masterData } from "./common.reducers";
import { roles } from "./roles.reducer";
//import upload from "./upload.reducer";
//import user from "./user.reducer";
//import unsubscribe from "./pro/unsubscribe.reducer";

import client from "./client/index";

//import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
  globalData,
  authentication,
  alert,
  //toastr: toastrReducer,
  masterData,
  roles,
  //  upload,
  //  user,
  //  unsubscribe,

  client,
});

export default rootReducer;
